// T039: Create permlink generation utility

/**
 * Generates a permlink from a title
 */
export function generatePermlink(title: string): string {
  const sanitized = title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
    .substring(0, 255)

  return sanitized || `post-${Date.now()}`
}

/**
 * Generates a unique comment permlink
 */
export function generateCommentPermlink(
  parentAuthor: string,
  parentPermlink: string
): string {
  const timestamp = Date.now()
  return `re-${parentAuthor}-${parentPermlink}-${timestamp}`
}

/**
 * Constructs a full Steemit URL for a post
 */
export function getPostUrl(category: string, author: string, permlink: string): string {
  return `https://steemit.com/${category}/@${author}/${permlink}`
}

/**
 * Constructs a full Steemit URL for a comment
 */
export function getCommentUrl(
  rootAuthor: string,
  rootPermlink: string,
  author: string,
  permlink: string
): string {
  return `https://steemit.com/@${rootAuthor}/${rootPermlink}#@${author}/${permlink}`
}

/**
 * Generates a unique permlink for Quick Post
 * Uses timestamp-based format: quick-post-{timestamp}
 */
export function generateQuickPostPermlink(): string {
  return `quick-post-${Date.now()}`
}
